export const SEARCH_HISTORY_SOURCE = {
  FMDIR_SEARCH_RESULT_PAGE: 'FMDirSearchResultsPage',
  FMDIR_CATEGORY_PAGE: 'FMDirCategoryPage'
}
